import React from 'react';

import Thumb from '../img/works/treehouse-home-page.jpg';
import Project from '../img/work-details/treehouse-home-page-project.jpg';
import Footer from '../img/work-details/treehouse-home-page-footer.jpg';

const TreehouseHomePage = {
    id: 2, permalink: "treehouse-home-page", thumb: Thumb, title: "Treehouse Home Page", category: "PSD to HTML", categoryURL: "psdtohtml", detailImg1: Project, detailImg2: Footer, previewTxt: "Preview", previewURL: "https://wasek23.github.io/treehouse-home-page/", sourceTxt: "PSD Source", sourceURL: "http://blazrobar.com/free-psd-website-templates/treehouse-website-psd-template/", description: <>
        <h3>Treehouse Home Page is a PSD To HTML Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Design With HTML5 &amp; CSS3</li>
            <li>Google Web Fonts Included</li>
            <li>Footer Social Share Icons</li>
            <li>Footer Weights</li>
        </ul>

        <h5>Unfavorable:</h5>
        <ul>
            <li>No Responsive</li>
        </ul>
    </>
};
export default TreehouseHomePage;